export default "https://assets-v2.scaler.com/packs/files/budz-pro.7533a2.webp";